import { Stack } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { myPalette } from '~/shared/lib/theme'
import { Circle, Degree, Img, ItemWrapper } from './styled'

export function Legend() {
  const { t } = useTranslation()
  return (
    <Stack
      direction='row'
      spacing={2}
      justifyContent='center'
      sx={{ fontSize: '12px' }}
    >
      <ItemWrapper>
        <Img src='/images/marker.svg' alt='marker' />
        {t('current inspection')}
      </ItemWrapper>
      <ItemWrapper>
        <Circle sx={{ background: myPalette.yellow['300'] }} />{' '}
        {t('old inspection')}
      </ItemWrapper>
      <ItemWrapper>
        <Circle sx={{ background: myPalette.brand['500'] }} />{' '}
        {t('selected in table')}
      </ItemWrapper>

      <ItemWrapper>
        <Degree>{t('damageParams.L')}</Degree> {t('damageParams.light')}
      </ItemWrapper>
      {/*<ItemWrapper>*/}
      {/*  <Degree>{t('damageParams.M')}</Degree>  {t('damageParams.medium')}*/}
      {/*</ItemWrapper>*/}
      <ItemWrapper>
        <Degree>{t('damageParams.S')}</Degree> {t('damageParams.severe')}
      </ItemWrapper>
    </Stack>
  )
}
